import React from 'react'
import { EntityTypeEnum, Permission, WorkflowActions } from 'api'
import { Locale, Translation } from 'locale'
import { TextButtonType, TextButton } from 'view/components/buttons'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { EntityTypeIdRecord } from 'store/notification/notificationTypes'
import { useDispatch } from 'react-redux'
import { createUserHasPermissionSelector } from 'selectors/userSelectors'
import { useSelector } from 'react-redux'
import { IssuerOrganisationDialog } from '../IssuerOrganisationDialog'

const canEditSelector = createUserHasPermissionSelector(Permission.ISSUER_ORGANISATION_MANAGE)

export const IssuerOrganisationsToolbarComponent: React.FC<ModalConsumerProps> = ({ showModal }) => {
  const dispatch = useDispatch()
  const canEdit = useSelector(canEditSelector)

  const handleAddIssuerOrganisation = () => {
    const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
      showModal(
        <IssuerOrganisationDialog
          workflowId={workflowId}
          issuerOrganisationEntityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.ISSUER_ORGANISATION]}
        />
      )
    }
    dispatch(WorkflowActions.createNewWorkflow(EntityTypeEnum.ISSUER_ORGANISATION, correlatedResponseCallback))
  }

  return (
    <TextButton
      dataTestId="IssuerOrganisationsToolbar-TextButton-ButtonAddIssuerOrganisation"
      type={TextButtonType.Primary}
      disabled={!canEdit}
      onClick={handleAddIssuerOrganisation}>
      {Locale.translate(Translation.TC_ADD_ISSUER_ORGANISATION)}
    </TextButton>
  )
}

export const IssuerOrganisationsToolbar = withModal(IssuerOrganisationsToolbarComponent)
